import './App.css';
import './lib/style/global.css';
import './lib/style/spacing.css';

import { createTheme, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import moment from 'moment';
import { PopUp } from './components/PopUp';
import { AppRoutes } from './lib/routes';
import { ScrollToTop } from './lib/routes/controllers';
import { BannerCookie } from './components/Banner';
import { getClient, getTheme, setClient } from './lib/info';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCustomTheme } from './store/custom-theme';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

export const App = (): JSX.Element => {
  moment.locale('it');
  dayjs.locale('it');

  const { iFrame, isPreview } = getClient();
  const [theme, setTheme] = useState(getTheme());
  const dispatch = useDispatch();
  // const { height, ref } = useResizeDetector()
  // let h = 0
  // useEffect(() => {
  //   if (iFrame !== null && iFrame) {
  //     console.log(height)
  //     if (height !== undefined && height !== h) {
  //       window.parent.postMessage(height, '*')
  //       h = height
  //     }
  //   }
  //   // window.postMessage(height?.current?.clientHeight, window.parent.location)
  // }, [height])

  useEffect(() => {
    if (isPreview) {
      const handleMessage = (event: MessageEvent) => {
        if (event.data.source !== 'blu-booking-preview') return;

        setTheme(event.data.payload.configurationJson);
        dispatch(setCustomTheme(event.data.payload.customConfigurationJson));
      };

      window.addEventListener('message', handleMessage);

      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, []);

  const themeP = useMemo(() => createTheme(theme), [theme]);

  return (
    <div style={{ padding: (iFrame ?? false) ? '0 10px' : 0 }} id="Test">
      <ThemeProvider theme={themeP}>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        <PopUp />
        <CssBaseline />
        <AppRoutes />
        <ScrollToTop />
        {!(iFrame ?? false) && <BannerCookie />}
      </ThemeProvider>
    </div>
  );
};
